import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import PublicSearch from "@/pages/PublicSearch";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import Normativa from "@/pages/Normativa";
import Contatti from "@/pages/Contatti";
import Richieste from "@/pages/admin/Richieste";
import DocumentView from "@/pages/DocumentView";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Condomini from "@/pages/admin/Condomini";
import Templates from "@/pages/admin/Templates";
import Account from "@/pages/admin/Account";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/informative" element={<PublicSearch />} />
          <Route path="/informativa-privacy-condomini" element={<PublicSearch />} />
          <Route path="/servizi/:slug" element={<ServicePage />} />
          <Route path="/normativa" element={<Normativa />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/documento/:cf/:tipo" element={<DocumentView />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="condomini" element={<Condomini />} />
            <Route path="modelli" element={<Templates />} />
            <Route path="richieste" element={<Richieste />} />
            <Route path="account" element={<Account />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
